import { Record } from "immutable";
import HubspotFieldTypes from "../../../constants/hubspot-field-types";
import { HubspotFormField } from "../../interfaces/hubspot/hubspot-form-field";

const defaultValues: HubspotFormField = {
    name: "",
    label: "",
    type: "",
    fieldType: HubspotFieldTypes.Text,
    description: "",
    groupName: "",
    displayOrder: "",
    required: false,
    enabled: false,
    hidden: false,
    placeholder: "",
    objectTypeId: "",
    options: [],
    value: "",
};

export default class HubspotFormFieldRecord
    extends Record(defaultValues)
    implements HubspotFormField
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: HubspotFormField) {
        if (params == null) params = Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor
    /**
     * Returns new object based on `this` and merges the partial values
     * @param  {Partial<HubspotFormField>} values
     * @returns HubspotFormFieldRecord
     */
    public with(values: Partial<HubspotFormField>): HubspotFormFieldRecord {
        return new HubspotFormFieldRecord(
            Object.assign(this.toJS(), values) as HubspotFormFieldRecord
        );
    }
}
